import { startOfDay, endOfDay, isSameDay, isBefore, isAfter, differenceInCalendarDays, add, endOfMonth } from 'date-fns';
import { chunk } from 'lodash';

export function startAndEndOfMonthsInRange(startDate, endDate, split) {
    let date = startOfDay(startDate);
    let results = [date];
    while (isBefore(date, endDate)) {
        let _date = endOfMonth(date);
        if (isSameDay(date, _date)) {
            date = startOfDay(add(date, { days: 1 }));
        }
        else date = _date;
        results.push(date);
    };
    if (split > 1) return chunk(results, split);
    return results;
};

export function enumerateDatesInRange(startDate, endDate) {
    var dates = [];

    var currDate = startOfDay(startDate);
    var lastDate = endOfDay(endDate);

    do {
        dates.push(currDate);
        currDate = add(currDate, { days: 1 })
    } while (differenceInCalendarDays(lastDate, currDate) >= 0);
    return dates;
};

export function isInRange(date, start, end) {
    return isSameOrAfter(date, start) && isSameOrBefore(date, end);
};

export function isSameOrAfter(dateL, dateR) {
    return isSameDay(dateL, dateR) || isAfter(dateL, dateR);
};

export function isSameOrBefore(dateL, dateR) {
    return isSameDay(dateL, dateR) || isBefore(dateL, dateR);
};
